import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./dialogues-create-payment-plan-styles";
import {
  Grid,
  Paper,
  Button,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Input,
  Select,
  Typography,
  IconButton,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { AllPaymentPlansContext } from "repository/stores/dashboard/payment-plans/payment-plans-all-provider";
// import { createNewPaymentPlan } from "repository/actions/data/dashboard/payment-plans";
import DateFnsUtils from "@date-io/date-fns";
import { toast } from "react-toastify";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import EuroIcon from "@material-ui/icons/Euro";
import { Delete } from "@material-ui/icons";
import Moment from "react-moment";
import moment from "moment";

const useStyles = makeStyles(styles);

function CreatePaymentPlanDialogue(props) {
  const classes = useStyles();
  const { setClose, isOpen, student, cohorts, user } = props;
  const {paymentPlans, setPaymentPlans, createNewPaymentPlan} = React.useContext(
    AllPaymentPlansContext
  );

  const [newEntry, setNewEntry] = React.useState({
    title: null,
    amount: null,
    date: null,
  });

  const [selectedCohortId, setSelectedCohortId] = React.useState(null);
  const [selectedCohort, setSelectedCohort] = React.useState(null);

  useEffect(() => {
    if (selectedCohortId && selectedCohortId != null) {
      for (let c of cohorts) {
        if (c._id == selectedCohortId) {
          setSelectedCohort(JSON.parse(JSON.stringify(c)));
          break;
        }
      }
    }
  }, [selectedCohortId]);

  const [saveLoading, setSaveLoading] = React.useState(null);

  const [titleError, setTitleError] = React.useState(null);
  const [dateError, setDateError] = React.useState(null);
  const [amountError, setAmountError] = React.useState(null);
  const [selectedCohortError, setSelectedCohortError] = React.useState(null);
  const [openDate, setOpenDate] = React.useState(false);

  const [entries, setEntries] = React.useState([]);

  const onPressedDeleteEntry = (index) => {
    if (entries.length > index) {
      let newEntries = [];

      for (let [i, e] of entries.entries()) {
        if (i != index) {
          newEntries.push(e);
        }
      }

      setEntries(newEntries);
    }
  };

  const handleSavePaymentPlanDetails = () => {
    if (user && user != null) {
      if (selectedCohort && selectedCohort != null) {
        if (entries.length <= 0) {
          toast.error("You need to at least add one payment entry.");
        } else {
          toast.dark(`Creating payment plan`);

          setSaveLoading(true);

          let paymentPlanPayload = {};

          paymentPlanPayload.entries = [];

          paymentPlanPayload.studentId = student._id;
          paymentPlanPayload.cohortId = selectedCohort._id;
          paymentPlanPayload.courseId = selectedCohort.courseId;

          for (let [i, e] of entries.entries()) {
            let parsedEntry = {};

            parsedEntry.title = e.title;
            parsedEntry.amount = parseFloat(e.amount);
            let dueMoment = new moment(e.date);
            parsedEntry.date = dueMoment.unix();
            paymentPlanPayload.entries.push(parsedEntry);
          }

          createNewPaymentPlan(
            paymentPlanPayload,
            user.idToken
          )
            .then((result) => {
              toast.success(`Payment plan successfully created`);
              setClose();
              setSaveLoading(false);
            })
            .catch((error) => {
              toast.error(
                "Oops! Something went wrong. Check that you have the correct information"
              );
              toast.dark(error.message);
              setSaveLoading(false);
            });
        }
      } else {
        toast.error("Please select a cohort for this payment plan");
      }
    }
  };

  const addPaymentEntry = () => {
    if (
      newEntry.date == null ||
      newEntry.title == null ||
      newEntry.amount == null
    ) {
      toast.error("You have missing information for a new payment entry");
      if (newEntry.date == null) {
        setDateError("Payment date is required.");
      }
      if (newEntry.title == null) {
        setTitleError("Payment name is required.");
      }
      if (newEntry.amount == null) {
        setAmountError("Payment amount is required.");
      }
    } else {
      setEntries(entries.concat(newEntry));
    }
  };

  useEffect(() => {
    setTitleError(null);
    setAmountError(null);
    setDateError(null);
    setSelectedCohortError(null);
    setSelectedCohort(null);
    setEntries([]);
  }, [isOpen]);

  useEffect(() => {
    setNewEntry({
      title: "",
      amount: "",
      date: null,
    });
  }, [entries]);

  return (
    <Popup
      title="Add a new payment plan"
      subtitle="Please fill in the details below to add a new payment plan to this student."
      isOpen={isOpen}
      fullWidth={true}
      maxWidth={"md"}
      handleCancel={() => setClose()}
      handleAction={() => handleSavePaymentPlanDetails()}
      actionButtonTitle="Submit"
      disabled={saveLoading}
      content={
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <FormControl className={classes.inputType}>
                    <InputLabel required disabled={saveLoading}>
                      Select Cohort
                    </InputLabel>
                    {cohorts && cohorts != null && (
                      <Select
                        elevation={0}
                        onChange={(event) =>
                          setSelectedCohortId(event.target.value)
                        }
                        value={selectedCohortId}
                        required
                        error={selectedCohortError != null}
                        disabled={saveLoading}
                        input={<Input id="type-menu" />}
                      >
                        {cohorts.map((item) => {
                          return (
                            <MenuItem value={item._id}>{item.title}</MenuItem>
                          );
                        })}
                      </Select>
                    )}
                  </FormControl>
                  <Typography variant="h6" className={classes.titleLight}>
                    Entries
                  </Typography>
                  <FormControl className={classes.formControl}>
                    <TextField
                      placeholder={"Ex: Module 1 Payment"}
                      disabled={saveLoading}
                      required
                      helperText={titleError}
                      error={titleError != null}
                      label="Title"
                      value={newEntry.title}
                      onChange={(event) =>
                        setNewEntry({ ...newEntry, title: event.target.value })
                      }
                    ></TextField>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      required
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Payment Date"
                      value={newEntry.date}
                      helperText={dateError}
                      error={dateError != null}
                      onChange={(date) => {
                        setNewEntry({ ...newEntry, date: date });
                        setOpenDate(false);
                      }}
                      onClick={() => setOpenDate(true)}
                      onError={(error) => setDateError(error.message)}
                      onOpen={() => setOpenDate(true)}
                      onClose={() => setOpenDate(false)}
                      open={openDate}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <TextField
                      placeholder={"Ex: 300"}
                      disabled={saveLoading}
                      required
                      helperText={amountError}
                      error={amountError != null}
                      label="Amount (€)"
                      value={newEntry.amount}
                      onChange={(event) =>
                        setNewEntry({ ...newEntry, amount: event.target.value })
                      }
                      margin="normal"
                      defaultValue={newEntry.date}
                    ></TextField>
                  </FormControl>
                </MuiPickersUtilsProvider>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => addPaymentEntry()}
                >
                  Add Entry
                </Button>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <List className={classes.root}>
                  {entries.map((entry, index) => {
                    return (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar>
                            <EuroIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={entry.title}
                          secondary={
                            <span>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                €{entry.amount} due on{" "}
                                <Moment
                                  format="D MMMM, YYYY"
                                  date={entry.date}
                                />
                              </Typography>
                              <IconButton
                                aria-label="delete"
                                color="primary"
                                onClick={(event) => {
                                  onPressedDeleteEntry(index);
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </span>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
}

export default withSnackbar(CreatePaymentPlanDialogue);
